import type { InteractiveLessonSectionComponentFragment } from '../../../lesson-builder.graphql.generated';
import {
  ACTIVITIES_COMPONENT_TYPE_INFO_BOX,
  BORDER_STYLE_BOX,
  BORDER_STYLE_INSTRUCTION,
  BORDER_STYLE_NONE,
  BORDER_STYLE_SPEECH,
  BORDER_STYLE_STATEMENT,
} from 'global/constants';
import { ComponentInfoBox } from '../../component.constants';

export function getTextComponentType(
  component: InteractiveLessonSectionComponentFragment
) {
  if (component.type === ACTIVITIES_COMPONENT_TYPE_INFO_BOX) {
    const style = (component as ComponentInfoBox).properties.style;
    return {
      isPlainText: style?.border === BORDER_STYLE_NONE,
      isStatementBox: style?.border === BORDER_STYLE_STATEMENT,
      isSpeechBubble: style?.border === BORDER_STYLE_SPEECH,
      isColouredBox: style?.border === BORDER_STYLE_BOX,
      isInstructionBox: style?.border === BORDER_STYLE_INSTRUCTION,
    };
  }
}
